import { Block } from "../../components/Block/Block";
import { Header } from "../../components/Header/Header";
import { FlexWrapper } from "../../components/FlexWrapper/FlexWrapper";
import { useNavigate, useParams } from "react-router";
import {
  CardDescription,
  ImageDesktop,
} from "../../components/CardDescription/CardDescription";
import { useEffect } from "react";
import { useAction, useAtom } from "@reatom/npm-react";
import {
  currentServiceAction,
  currentServiceAtom,
  currentServiceIsLoadingAtom,
  currentServiceIsLoadingCalculateAtom,
  extraAtom,
} from "../../core/reatom/state/currentService/currentService";
import { Garanty } from "../../components/Garanty/Garanty";
import { AdditionalOptions } from "../../components/AdditionalOptions/AdditionalOptions";
import { ServiceEpic } from "../../components/ServiceEpic/ServiceEpic";
import s from "./style.module.scss";
import { createOrderAction } from "@/core/reatom/state/orders/orders";
export const CurrentServicePage = () => {
  const { id } = useParams();
  const handleFetchCurrentServiceCard = useAction(currentServiceAction);
  useEffect(() => {
    handleFetchCurrentServiceCard(id ?? "");
  }, []);
  const [currentService] = useAtom(currentServiceAtom);
  const [isLoadingAtom] = useAtom(currentServiceIsLoadingAtom);
  const [isLoadingSummaryAtom] = useAtom(currentServiceIsLoadingCalculateAtom);
  const handleCreateOrder = useAction(createOrderAction);
  const [extra] = useAtom(extraAtom);
  const navigate = useNavigate();

  return (
    <div className={s.scrollWrapper}>
      <Header title="FL.ru" />
      <FlexWrapper className={s.mobile}>
        <Block borderRadius="bottom">
          <CardDescription />
        </Block>
        <Block>
          <Garanty
            days={currentService?.days}
            price={currentService?.price.amount}
            isLoadingAtom={isLoadingAtom}
            isLoadingSummaryAtom={isLoadingSummaryAtom}
          />
        </Block>
        {currentService && currentService.extra.length > 0 && (
          <Block>
            <AdditionalOptions />
          </Block>
        )}
      </FlexWrapper>
      <FlexWrapper className={s.desktop}>
        <Block borderRadius="bottom" className={s.card}>
          <CardDescription />
        </Block>
        <FlexWrapper className={s.card}>
          <ImageDesktop />
          <Block>
            <Garanty
              days={currentService?.days}
              price={currentService?.price.amount}
              isLoadingAtom={isLoadingAtom}
              isLoadingSummaryAtom={isLoadingSummaryAtom}
            />
          </Block>
          {currentService && currentService.extra.length > 0 && (
            <Block>
              <AdditionalOptions />
            </Block>
          )}
        </FlexWrapper>
      </FlexWrapper>
      <ServiceEpic
        createOrder={() => {
          if (currentService) {
            handleCreateOrder({ cardId: currentService?.id, extra }).then(
              () => {
                navigate("/checkout/" + currentService?.id);
              }
            );
          }
        }}
      />
    </div>
  );
};
